import { render, staticRenderFns } from "./Disposal.vue?vue&type=template&id=11e5d113&scoped=true"
import script from "./Disposal.vue?vue&type=script&lang=js"
export * from "./Disposal.vue?vue&type=script&lang=js"
import style0 from "./Disposal.vue?vue&type=style&index=0&id=11e5d113&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e5d113",
  null
  
)

export default component.exports